import React from "react";
import Link from "@qlik/qlik/src/components/Link";
import { getCardBodyContent, renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import { useI18n } from "@qlik/utils/i18nContext";

const CardWithNoBorderImage = ({ data }) => {
    const { component, browsingContext } = data ?? {};
    const { i18n } = useI18n();

    const href =
        component?.cta?.[0]?.internalLink !== null
            ? i18n.getLangPrefixedPath(`/${component?.cta?.[0]?.internalLink?.slug}`)
            : component?.cta?.[0]?.externalUrl;
    const title = component?.title;
    const text = component?.cta?.[0]?.text;
    const paragraph = getCardBodyContent(component, "richtext-mb-0");

    const linkProps = {
        className: "z-1 group/link relative block",
        newWindow: browsingContext === "New Tab",
        to: href,
    };

    return (
        <Link {...linkProps}>
            <span className="-z-1 absolute -inset-4 rounded bg-white shadow-xlSmall opacity-0 transition-opacity transition-300 xl:group-hover/link:opacity-100" />
            <div className="card-no-border">
                {title && (
                    <h3
                        className="card-title title-4"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                    />
                )}
                {paragraph && <div className="mt-2.5">{paragraph}</div>}
                {text && (
                    <span className="green-link mt-7.25 xl:group-hover/link:text-dark-green xl:group-hover/link:after:arrow-green-dark xl:group-hover/link:after:translate-x-0.75">
                        {text}
                    </span>
                )}
            </div>
        </Link>
    );
};
export default CardWithNoBorderImage;
